// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"25":"8ae52bb1af9312ab","31":"396440c693173c3e","793":"42ef63b7ec463244"}[chunkId] + ".js";
};